export class EnvService {

  public production = false;

  public DefaultLocale = "en-us";

  public BuildTime = "0";

  public SupportedLocales = [
    "en-us",
    "ar",
    "id",
    "ms",
    "bg",
    "zh",
    "zh-hans",
    "hr",
    "cs",
    "da",
    "nl",
    "en",
    "et",
    "fi",
    "fr",
    "fr-ca",
    "de",
    "el",
    "hu",
    "is",
    "it",
    "ja",
    "ko",
    "lv",
    "lt",
    "nb",
    "pl",
    "pt-br",
    "pt",
    "ro",
    "ru",
    "sl",
    "es",
    "es-es",
    "sv",
    "th",
    "tr"
  ];

  public defaultLogLevel = 2;
  public stgLogLevel = 7;
  public qaLogLevel = 1;
  public prodLogLevel = 7;
  public sbxLogLevel = 1;
  public demoLoggerLevel = 7;

  constructor() {
    // Get injected UI buildtime for cache busting language strings based on new build.
    const browserWindow = window || {};
    const browserWindowEnv = browserWindow["__env"] || {};
    if (browserWindowEnv.hasOwnProperty("BuildTime")){
      this.BuildTime = browserWindowEnv["BuildTime"];
    }
  }

}
